/**
 * remove-formatting
 *
 * @module remove-formatting
 */
const component = {

    /**
     * Init module
     * 
     * @returns {boolean|undefined}
     */
    init: () => {

		component.target = document.querySelector("remove-formatting");

		if(!component.target) return false;

        component._initEvents();
	},

    /**
     * @returns {undefined}
	 */
    _initEvents: () => {

        let html = component.target.innerHTML;

        html = html.replace(/<(h[1-6]|ul|li)[^>]*>/g, '<p>');
        html = html.replace(/<\/(h[1-6]|ul|li)>/g, '</p>');

        component.target.innerHTML = html;
    },

}

export default component;